"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Styled = require("./Styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RadioButton = function RadioButton(_ref) {
  var id = _ref.id,
      name = _ref.name,
      className = _ref.className,
      value = _ref.value,
      label = _ref.label,
      checked = _ref.checked,
      disabled = _ref.disabled,
      dark = _ref.dark,
      status = _ref.status,
      marginTop = _ref.marginTop,
      marginRight = _ref.marginRight,
      marginBottom = _ref.marginBottom,
      marginLeft = _ref.marginLeft,
      rest = _objectWithoutProperties(_ref, ["id", "name", "className", "value", "label", "checked", "disabled", "dark", "status", "marginTop", "marginRight", "marginBottom", "marginLeft"]);

  var radioId = id || name;
  return /*#__PURE__*/_react.default.createElement(_Styled.GenericDiv, _extends({
    className: className,
    dark: dark,
    status: status
  }, {
    marginTop: marginTop,
    marginRight: marginRight,
    marginBottom: marginBottom,
    marginLeft: marginLeft
  }), /*#__PURE__*/_react.default.createElement(_Styled.Label, {
    htmlFor: radioId
  }, /*#__PURE__*/_react.default.createElement(_Styled.RadioButtonStyled, {
    disabled: disabled,
    checked: checked
  }), /*#__PURE__*/_react.default.createElement(_Styled.RadioButtonHidden, _extends({
    id: radioId,
    name: name,
    value: value,
    type: "radio",
    disabled: disabled,
    checked: checked
  }, rest)), label));
};

RadioButton.defaultProps = {
  id: undefined,
  name: undefined,
  className: '',
  label: '',
  value: '',
  checked: false,
  disabled: false,
  dark: false,
  status: '',
  marginTop: 'none',
  marginRight: 'none',
  marginBottom: 'xs',
  marginLeft: 'none'
};
RadioButton.propTypes = {
  id: _propTypes.string,
  name: _propTypes.string,
  className: _propTypes.string,
  label: _propTypes.string,
  value: _propTypes.string,
  checked: _propTypes.bool,
  disabled: _propTypes.bool,
  dark: _propTypes.bool,
  status: (0, _propTypes.oneOf)(['', 'error']),
  marginTop: _propTypes.string,
  marginRight: _propTypes.string,
  marginBottom: _propTypes.string,
  marginLeft: _propTypes.string
};
RadioButton.displayName = 'RadioButton';
var _default = RadioButton;
exports.default = _default;